import type { AuthRepositoryPort, LoginCredentials } from "../ports/auth.repository.port";

export function loginUseCase(repository: AuthRepositoryPort, credentials: LoginCredentials) {
  return repository.login(credentials);
}

export function doctorLoginUseCase(repository: AuthRepositoryPort, credentials: LoginCredentials) {
  return repository.doctorLogin(credentials);
}

export function googleLoginUseCase(repository: AuthRepositoryPort, idToken: string) {
  return repository.googleLogin(idToken);
}

